import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"

function Survey({t, onChangeLoadPage, items}){

    const onChangeLoadPageTrazability = (obj) => {
        onChangeLoadPage(obj);    
    };

    return (
        <Container className="my-5">
            <h2 className="mb-0 title-top">Encuesta</h2>

            <Row className="mt-4">
                <Col xs="6" md="6">
                    <h6>Doctor</h6>
                    <Row>
                    {
                        (items.Doctor && items.Doctor.length) ? items?.Doctor.map((item, i)=>(
                            <Col xs="12" md="12" key={i}>
                                <Card className="shadow-1 mb-2">
                                    <Card.Body>  
                                        <div className="mb-2">
                                            <span className="font-size-09rem mb-2 font-weight-bold-600">{item.survey.title}</span>
                                            {
                                                item.answers.map((a, ind)=>(
                                                    <span key={ind} className="d-block font-size-09rem pl-1">{a}</span>
                                                ))
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col> 
                        )):
                        <Col>
                            <Card className="shadow-1 mb-2">
                                <Card.Body>  
                                    No hay información que mostrar
                                </Card.Body>
                            </Card>
                        </Col>
                    } 
                    </Row>
                </Col>
                <Col xs="6" md="6">
                    <h6>Paciente</h6>
                    <Row>
                    {
                        (items.Patient && items.Patient.length) ? items.Patient.map((item, i)=>(
                            <Col xs="12" md="12" key={i}>
                                <Card className="shadow-1 mb-2">
                                    <Card.Body>  
                                        <div className="mb-2">
                                            <span className="font-size-09rem mb-2 font-weight-bold-600">{item.survey.title}</span>
                                            {
                                                item.answers.map((a, ind)=>(
                                                    <span key={ind} className="d-block font-size-09rem pl-1">{a}</span>
                                                ))
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )):
                        <Col>
                            <Card className="shadow-1 mb-2">
                                <Card.Body>  
                                    No hay información que mostrar
                                </Card.Body>
                            </Card>
                        </Col>
                    } 
                    </Row>
                </Col>                               
            </Row>
            <Row className='mt-3'>
                <Col className="text-right">
                <Button type="button" variant="danger" className="cancelar-buttom" onClick={() => {onChangeLoadPageTrazability({view: "trazabilidad"})}}>Regresar</Button>
                </Col>
            </Row>
        </Container>
        

    )
}

export default withTranslation()(Survey)